import * as React from 'react';
import { MeatballMenu, Validation, ValidationLevel } from 'ui';
import { FIELD_TYPE, ValidationRule, ValidationType } from 'app/infrastructure/simple-form';
import { SerializeType } from 'app/infrastructure/simple-form/types';
import { AlternativeIdItemProps } from './types';
import { alternativeIdFieldName } from './constants';

import style from './alternative-id-item.scss';
import { sfNames } from 'app/area/administration/edit/sf-names';

export class AlternativeIdItem extends React.PureComponent<AlternativeIdItemProps> {

  private onRemove = () => {
    !!this.props.onRemove && this.props.onRemove(this.props.data);
  }

  public render() {

    const { data, formValues = {}, validateFields = [], validation, readOnly, translation, formComponent: SimpleForm } = this.props;

    if (!data) {
      return null;
    }

    const personIdFormValue = formValues[alternativeIdFieldName(sfNames.personId, data.id)] as string;
    const nameFormValue = formValues[alternativeIdFieldName(sfNames.name, data.id)] as string;

    const validationPersonId = validation && validation.messages
      && validation.messages.filter(m => m.parameters && m.parameters.personId === personIdFormValue?.trim?.());

    const validationName = validation && validation.messages
      && validation.messages.filter(m => m.parameters && m.parameters.name === nameFormValue?.trim?.());

    const hasPersonIdErrors = !!validationPersonId && validationPersonId.length > 0;
    const hasNameErrors = !!validationName && validationName.length > 0;

    return <div className={style.item}>
      {!readOnly && <div className={style.header}>
        <MeatballMenu closeAfterClick={true}>
          <li>
            <button type="button" className="dropdown-item" onClick={this.onRemove}>
              {translation.remove}
            </button>
          </li>
        </MeatballMenu>
      </div>}
      <div className="row">
        <div className={`col-lg-5 col-sm-12 ${hasPersonIdErrors ? 'has-danger' : ''}`}>
          <SimpleForm
            name={alternativeIdFieldName(sfNames.personId, data.id)}
            maxLength={80}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.alternative_id, required: !readOnly }}
            initialValue={data && data.personId}
            validationProps={[
              { type: ValidationType.Required },
              {
                type: ValidationType.Unique,
                fields: validateFields
                  .filter(id => id !== data.id)
                  .map(id => alternativeIdFieldName(sfNames.personId, id)),
                rules: [ValidationRule.IgnoreCaseSensitivity]
              }
            ]}
            readOnly={readOnly}
          />
          {hasPersonIdErrors && <div className={style.validation}>
            <Validation level={ValidationLevel.error} messages={validationPersonId} />
          </div>}
        </div>
        <div className={`col-lg-5 col-sm-12 ${hasNameErrors ? 'has-danger' : ''}`}>
          <SimpleForm
            name={alternativeIdFieldName(sfNames.name, data.id)}
            maxLength={254}
            type={FIELD_TYPE.TEXTAREA}
            label={{ text: translation.name, required: !readOnly }}
            initialValue={data && data.name}
            serialize={{
              type: SerializeType.VALUE_PAIRS,
              formName: sfNames.alternativeIds,
              valueKey: sfNames.name,
              groupKey: sfNames.personId,
              groupField: alternativeIdFieldName(sfNames.personId, data.id)
            }}
            validationProps={[
              { type: ValidationType.Required },
              {
                type: ValidationType.Unique,
                fields: validateFields
                  .filter(id => id !== data.id)
                  .map(id => alternativeIdFieldName(sfNames.name, id)),
                rules: [ValidationRule.IgnoreCaseSensitivity]
              }]}
            readOnly={readOnly}
          />
          {hasNameErrors && <div className={style.validation}>
            <Validation level={ValidationLevel.error} messages={validationName} />
          </div>}
        </div>
      </div>
    </div>;
  }
}
